import { BrandedTrackingSection } from '@/components';

const SettingsBrandedTracking = () => {
  return <BrandedTrackingSection />;
};

export default SettingsBrandedTracking;
